import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { renderPermitV2 } from "../../../print-v2";

const PermitTest = ({ permit, voyage, companyLogo, isEditMode }) => {
  const [formState, setFormState] = useState({
    field1: permit.field1 || "",
    field2: permit.field2 || "",
    checkboxes: permit.checkboxes || [
      { label: "Safety briefing done", checked: false },
      { label: "Equipment inspected", checked: false },
      { label: "Area cordoned off", checked: false },
    ],
  });

  const handleInputChange = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleCheckboxChange = (index, checked) => {
    const updated = [...formState.checkboxes];
    updated[index].checked = checked;
    setFormState((prev) => ({ ...prev, checkboxes: updated }));
  };

  const handlePrint = () => {
    renderPermitV2({
      companyLogo,
      voyage,
      permit: { ...permit, ...formState },
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6">{permit.title}</Typography>

      {/* Inputs */}
      <TextField
        label="Field 1"
        value={formState.field1}
        disabled={!isEditMode}
        onChange={(e) => handleInputChange("field1", e.target.value)}
      />
      <TextField
        label="Field 2"
        value={formState.field2}
        disabled={!isEditMode}
        onChange={(e) => handleInputChange("field2", e.target.value)}
      />

      {/* Checkboxar */}
      {formState.checkboxes.map((cb, i) => (
        <FormControlLabel
          key={i}
          control={
            <Checkbox
              checked={cb.checked}
              disabled={!isEditMode}
              onChange={(e) => handleCheckboxChange(i, e.target.checked)}
            />
          }
          label={cb.label}
        />
      ))}

      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handlePrint}
          startIcon={<PrintIcon />}
        >
          Print Permit
        </Button>
      </Box>
    </Box>
  );
};

export default PermitTest;
